module.exports = __webpack_public_path__ + "img/hr-tree-03-b-trunk.06447ec5.png";